/**
 * Browser Store Implementation
 * Wraps a platform storage adapter (LocalStorageAdapter/ChromeStorageAdapter)
 * to conform to the Store interface used by myagent_session
 */

const KNOWN_COLLECTIONS = ['metadata', 'llm', 'conv:main', 'conv_index', 'compressed', 'notes']

export class BrowserStore {
  constructor(storageAdapter) {
    this.adapter = storageAdapter
  }

  _key(namespace, userId, collection) {
    return `myagent_store:${namespace}:${userId}:${collection}`
  }

  async get(namespace, userId, collection) {
    const raw = await this.adapter.get(this._key(namespace, userId, collection))
    if (!raw) return null
    try {
      return JSON.parse(raw)
    } catch (e) {
      throw new Error(`[BrowserStore] Corrupted data for ${collection}: ${e.message}`)
    }
  }

  async set(namespace, userId, collection, data) {
    await this.adapter.set(this._key(namespace, userId, collection), JSON.stringify(data))
  }

  async remove(namespace, userId, collection) {
    await this.adapter.remove(this._key(namespace, userId, collection))
  }

  async clear(namespace, userId) {
    for (const collection of KNOWN_COLLECTIONS) {
      await this.adapter.remove(this._key(namespace, userId, collection))
    }
  }
}
